$(document).ready(function () {
    const $slider = $('.block__icon-info-slider');
    let isPaused = false;
    const autoplaySpeed = parseInt($slider.data('time'), 10) || 15000;

    $slider.slick({
        dots: true,
        arrows: false,
        infinite: true,
        speed: 500,
        fade: true,
        cssEase: 'ease',
        autoplay: true,
        autoplaySpeed: autoplaySpeed,
        appendDots: $('.block__icon-info-dots'), // ⭐ APPEND DOTS HERE
        pauseOnHover: false,
        pauseOnFocus: false,
        pauseOnDotsHover: false,
    });

    // PAUSE / PLAY TOGGLE
    function togglePlayPause() {
        if (!isPaused) {
            $slider.slick('slickPause');
            isPaused = true;
            $('.block__icon-info-btn').removeClass('paused');
            $('.block__icon-info-btn').addClass('play');
        } else {
            $slider.slick('slickPlay');
            isPaused = false;
            $('.block__icon-info-btn').removeClass('play');
            $('.block__icon-info-btn').addClass('paused');
        }
    }

    $('.block__icon-info-slider').on('click', togglePlayPause);
    $('.block__icon-info-btn').on('click', function (e) {
        e.stopPropagation();
        togglePlayPause();
    });

    // ⭐ Keep dots working when paused
    $('.block__icon-info-dots').on('click', 'li', function () {
        if (isPaused) {
            $slider.slick('slickGoTo', $(this).index());
        }
    });
});
